export const works = [
  {id: 0, client: "Lancôme", director: "Audrey Mascina", video: "video2.mp4", img: "/medias/photo1.png"},
  {id: 1, client: "Atelier Molinari", director: "Robin Gobert", video: "video1.mp4", img: "/medias/photo2.png", text_is_dark: true},
  {id: 2, client: "James Vincent McMorrow", director: "Angues Lee Forbes", video: "video3.mp4", img: "/medias/photo3.jpg", text_is_dark: true},
  {id: 3, client: "Dior", director: "Thomas Keen", video: "video4.mp4", img: "/medias/photo4.png"},
]

export const extractedImgs = works.map(m => ({
  id: m.id,
  src: m.img,
  primary: m.client,
  secondary: m.director,
  text_is_dark: m.text_is_dark
}))

const random_bio_text = `Her background as a professional dancer and musician gave her a taste and a singular point of view on directing. A memory of feelings that led her to develop a visual and narrative writing both physical and poetical. Her relationship to space, rythme and movement give to each of her films a brutal but sensitive energy. 

Sensual and committed, her camera puts in light the trueness of the bodies, the subjects and the situations in a constant research of intensity and accuracy.`
const random_bio_sub = "AUDREY’S IMAGINARY WORLD STARTED THROUGH DANCE AND MUSIC"

const random_socials = [
  {id: 0, label: "Vimeo", href: "/"},
  {id: 1, label: "Instagram", href: "/"},
]

export const directors = [
  {id: 0, name: "Alizée Andrejka", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 1, name: "Angus Lee Forbes", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 2, name: "Alix", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 3, name: "Audrey Mascina", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 4, name: "Kate McMullen", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 5, name: "Robin Gobert", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 6, name: "Sebastien Alfie", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
  {id: 7, name: "Thomas", biography_text: random_bio_text, biography_subtitle: random_bio_sub, socials: random_socials, imgs: extractedImgs},
]


export const contacts = {
  links: [
    {label: "54 rue oberkampf, 75011 PARIS", href: "https://goo.gl/maps/XghXh3uPSCshaQTL6", type: "external"},
    {label: "contact@ubiquity-films.com", href: "contact@ubiquity-films.com", type: "mail"},
    {label: "+33 (0)6 87 68 01 93", href: "0687680193", type: "phone"},
    {label: "instagram", href: "https://www.instagram.com/ubiquityfilms", type: "external"},
  ],
  members: [
    {fullname: "Clément GAUCHER-HOLMANN", job: "Executive Producer", mail: "clementgaucher@hotmail.com"},
    {fullname: "Jérémy bouvier", job: "Development", mail: "jeremyvoubier@hotmail.com"},
    {fullname: "Gautier LACAILLE ARANDA", job: "Commercial", mail: "gautierlacaille@hotmail.com"},
  ]
}